<template>
  <v-card elevation="0">
    <vue-table
      :data="transactionData"
      :headers="headers"
      :loading.sync="loading"
      :props.sync="tableProps"
      @change="onPagination"
    >
      <template v-slot:filters="{ props, perPage }">
        <v-row class="pa-4">
          <v-col cols="12" md="6" lg="3">
            <v-combobox
              :items="page"
              :label="`تعداد نمایش`"
              append-icon="mdi-chevron-down"
              dense
              outlined
              v-model="props.length"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-combobox
              :items="services"
              :label="`سرویس`"
              append-icon="mdi-chevron-down"
              dense
              outlined
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <commercial-qr-type v-model="selectQrType" />
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <commercial-status-filter
              v-model="selectActive.type"
              :count="selectActive.count"
              :has-error="selectActive.error"
            />
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <commercial-user-picker
              v-model="userpicker.users"
              :api-url="userpicker.apiUrl"
              :errors="userpicker.apiUrl"
            />
          </v-col>
          <!-- <v-col cols="12" md="6" lg="3">
            <date-picker
              v-model="time.start_time"
              clearable
              display-format="jYYYY-jMM-jDD"
              format="YYYY-MM-DD"
              label="از تاریخ"
            />
          </v-col> -->
          <!-- <v-col cols="12" md="6" lg="3">
            <date-picker
              v-model="time.end_time"
              clearable
              display-format="jYYYY-jMM-jDD"
              format="YYYY-MM-DD"
              label="تا تاریخ"
            />
          </v-col> -->
          <v-col cols="12" md="6" lg="3">
            <v-text-field
              outlined
              dense
              append-icon="mdi-pencil"
              label="توضیحات"
            />
          </v-col>
        </v-row>

        <!-- @confirm="onConfirmSelection" -->
      </template>

      <template v-slot:index="{ item }">
        {{ transactionData.data.findIndex((data) => data.id == item.id) + 1 }}
      </template>
      <template v-slot:qrName="{ item }">
        {{ item.qrName }}
      </template>

      <template v-slot:price="{ item }">
        <v-btn
          color="#f28b82
"
          class="white--text"
          elevation="0"
          width="100px"
        >
          {{ item.price.toLocaleString() }}
        </v-btn>
      </template>

      <template v-slot:name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:description="{ item }">
        {{ item.description }}
      </template>

      <template v-slot:type="{ item }">
        <v-btn
          color="#a0c8e8"
          class="white--text"
          flt
          elevation="0"
          width="100px"
          >{{ showType(item.type) }}</v-btn
        >
      </template>

      <template v-slot:pay_due_days="{ item }">
        {{ item.pay_due_days }}
      </template>

      <template v-slot:due_days="{ item }">
        {{ item.due_days }}
      </template>

      <template v-slot:payment_id="{ item }">
        {{ item.payment_id }}
      </template>

      <template v-slot:fine="{ item }">
        {{ item.fine }}
      </template>

      <template v-slot:status="{ item }">
        <v-btn
          elevation="0"
          width="35px"
          class="white--text"
          :color="showStatus(item.status).color"
          >{{ showStatus(item.status).text }}</v-btn
        >
      </template>
    </vue-table>
  </v-card>
</template>

<script>
import commercialUserPicker from "./commercialUserPicker.vue";
import commercialStatusFilter from "./commercialStatusFilter.vue";
import CommercialQrType from "./commercialQrType.vue";

export default {
  name: "commericalReserveAdmin",
  components: {
    commercialUserPicker,
    CommercialQrType,
    commercialStatusFilter,
  },
  data() {
    return {
      page: ["10", "20", "30", "40", "50"],
      actionType: false,
      selectQrType: "all",
      services: [
        { value: "banner", text: "رزرو بنر" },
        { value: "space", text: "رزرو فضا" },
      ],
      headers: [
        { text: "ردیف", value: "index", align: "center" },
        {
          text: "نام کیوآر",
          value: "qrName",
          align: "center",
          sortable: false,
        },
        { text: "نام", value: "name", align: "center" },
        { text: "توضیحات", value: "description", align: "center" },
        { text: "مبلغ", value: "price", align: "center" },
        { text: "نوع سرویس", value: "type", align: "center" },
        { text: "تاریخ پرداخت", value: "pay_due_days", align: "center" },
        {
          text: "تاریخ شروع رزرو",
          value: "reserve_due_days_start",
          align: "center",
        },
        {
          text: "تاریخ پایان رزرو",
          value: "reserve_due_days_end",
          align: "center",
        },
        { text: "شناسه پرداخت", value: "payment_id", align: "center" },
        { text: "وضعیت", value: "status", align: "center" },
      ],
      transactionData: {
        data: [
          {
            index: 1,
            qrName: "لباس فروشی لاله",
            name: "احمد رضا یوسفی",
            description: "پرداخت اجاره خرداد",
            price: 1200000,
            type: "banner",
            pay_due_days: "1404/05/01",
            reserve_due_days_start: "1404/05/01",
            reserve_due_days_end: "1404/05/08",
            payment_id: "25363625",
            status: "pending",
          },
          {
            index: 2,
            qrName: "کفش فروشی نازی",
            name: "رضا جابر",
            description: "پرداخت اجاره ",
            price: 350000,
            type: "banner",
            pay_due_days: "1404/05/02",
            reserve_due_days_start: "1404/05/02",
            reserve_due_days_end: "1404/05/09",
            payment_id: "25363626",
            status: "pending",
          },
          {
            index: 3,
            qrName: "فروشگاه مهران",
            name: "محمد انضاری",
            description: "پرداخت اجاره ",
            price: 1350000,
            type: "space",
            pay_due_days: "1404/05/03",
            reserve_due_days_start: "1404/05/03",
            reserve_due_days_end: "1404/05/10",
            payment_id: "25363627",
            status: "pending",
          },
          {
            index: 4,
            qrName: "سوپرمارکت آرش",
            name: "الهه دهقان",
            description: "پرداخت اجاره ",
            price: 280000,
            type: "space",
            pay_due_days: "1404/05/04",
            reserve_due_days_start: "1404/05/04",
            reserve_due_days_end: "1404/05/11",
            payment_id: "25363628",
            status: "pending",
          },
          {
            index: 5,
            qrName: "کتاب‌فروشی ققنوس",
            name: "رضا مروت",
            description: "پرداخت اجاره مرداد",
            price: 1100000,
            type: "banner",
            pay_due_days: "1404/05/05",
            reserve_due_days_start: "1404/05/05",
            reserve_due_days_end: "1404/05/12",
            payment_id: "25363629",
            status: "pending",
          },
          {
            index: 6,
            qrName: "کتاب‌فروشی ققنوس",
            name: "علی کاظمی",
            description: " پرداخت اجاره مرداد",
            price: 420000,
            type: "space",
            pay_due_days: "1404/05/05",
            reserve_due_days_start: "1404/05/05",
            reserve_due_days_end: "1404/05/12",
            payment_id: "25363630",
            status: "pending",
          },
        ],
        total: 10,
        page: 2,
        per_page: 10,
      },
      loading: false,
      tableProps: {
        search: "",
        length: 10,
        productId: [],
        column: "id",
        dir: "desc",
        page: 1,
      },
      userpicker: {
        users: [],
        apiUrl: "/api/user",
        errors: [],
      },
      time: {
        start_time: "",
        end_time: "",
      },
      selectActive: {
        type: "all",
        count: 1,
        error: false,
      },
    };
  },

  methods: {
    showStatus(e) {
      switch (e) {
        case "pay":
          return { text: "پرداخت شده", status: 1, color: "green" };
        case "unpaid":
          return { text: "پرداخت نشده", status: 0, color: "red" };

        case "pending":
          return { text: "در انتظار تایید", status: 2, color: "yellow" };

        default:
          return { text: "نا مشخص", status: -1, color: "primary" };
      }
    },
    showType(e) {
      switch (e) {
        case "rent":
          return "اجاره";
        case "charge":
          return "شارژ";
        case "banner":
          return "اجاره بنر";
        case "space":
          return "اجاره فضای تبلیغاتی";
      }
    },
  },
};
</script>

<style></style>
